import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function GasPipeIcon(props) {
	return (
		<IconBase type="gas-pipe" {...props}>
			<path d="M14.1651 8.25C13.4747 9.44573 11.9458 9.85542 10.75 9.16506C9.55432 8.47471 9.14464 6.94573 9.83499 5.75C10.5253 4.55427 12.0543 4.14458 13.25 4.83494C14.4458 5.52529 14.8554 7.05427 14.1651 8.25ZM12.6585 5.35946L11.6585 7.09151C11.5895 7.21108 11.6305 7.36398 11.75 7.43301C11.8696 7.50205 12.0225 7.46108 12.0915 7.34151L13.0915 5.60946C13.1606 5.48988 13.1196 5.33698 13 5.26795C12.8805 5.19891 12.7276 5.23988 12.6585 5.35946Z" />
			<path d="M16 7C16 8.86384 14.7252 10.4299 13 10.874V12H13.5C13.7761 12 14 12.2239 14 12.5V13H15.5V20H8.5V13H10V12.5C10 12.2239 10.2239 12 10.5 12H11V10.874C9.27477 10.4299 8 8.86384 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7ZM12 10C13.6569 10 15 8.65685 15 7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7C9 8.65685 10.3431 10 12 10Z" />
			<path d="M2 13.5H5V19.5H2V13.5Z" />
			<path d="M22 13.5H19V19.5H22V13.5Z" />
			<path d="M5.5 12H6.5V21H5.5V12Z" />
			<path d="M17 12H16V21H17V12Z" />
			<path d="M7 12H8V21H7V12Z" />
			<path d="M18.5 12H17.5V21H18.5V12Z" />
		</IconBase>
	);
}
GasPipeIcon.propTypes = iconPropTypes;
